import React from 'react'
import themes from '@/utils/themes'

export default React.createContext(
  themes.base
)
